import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';


export default function ConfirmationDialog({
    title,
    body,
    startsOpen=true,
    onConfirm,
    onCancel,
    confirmText = 'OK',
    cancelText = 'Cancel',
}) {
    const [open, setOpen] = React.useState(startsOpen);

    const handleCancel = () => {
        setOpen(false);
        if (onCancel) onCancel()
    }

    const handleConfirm = () => {
        setOpen(false);
        if (onConfirm) onConfirm()
    }


    return (
        <Dialog
            open={open}

        >
            <DialogContent  sx={{minWidth:'26em'}}>
                {body}
            </DialogContent>
            <DialogActions>
                <Button variant='contained' onClick={handleCancel}>
                    {cancelText}
                </Button>
                <Button variant='contained'  onClick={handleConfirm}>
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    )
}